/* eslint-disable max-len */

export default {
  errors: {
    global: {
      internal: '网络错误',
      not_allowed: '操作不允许',
      access_denied: '拒绝访问',
      validator_error: '验证器错误{details}',
      wrong_body: 'Wrong body',
      wrong_token: '错误的令牌',
      missing_token: '缺少令牌',
      exclusive_lock: '单独锁定',
      access_denied_acl: '拒绝访问（访问控制列表）',
      connection_timeout: '连接超时',
      login_required: '必需登录',
      not_found: '未找到',
      wrong_value: '错误的值',
      token_expired: '令牌已过期',
      service_not_available: '服务不可用',
      twofa_required: '需要2FA身份验证',
      missing_login_token: '必需登录',
    },
    account: {
      banned: '账户被禁用',
      wrong_login_or_password: '错误的用户名或密码',
      wrong_login: '用户名错误',
      wrong_password: '密码错误',
      blocked: '账户被封锁',
      missing_email: '邮箱地址未被分配',
      same_password_used: '使用了相同的密码',
      apikey_not_created: 'API密钥未创建',
      apikey_already_created: 'API密钥已经创建',
      twofa_not_created: '2FA未创建',
      twofa_already_created: '2FA已经创建',
      deletion_already_started: '账户删除已经开始',
      wrong_twofa: '错误的2FA验证码',
      external_withdraw_not_available: '无法进行外部提现',
      twofa_limit: '2FA限制',
      kyc_wrong_step: 'KYC步骤错误',
      not_exists: '不存在',
      kyc_required: '必需KYC',
      action_not_allowed: '操作不允许',
      migration: 'Migration',
      wrong_password_pattern: '密码需要8到64个字符且其中最少包含1个：大写字母，小写字母，数字，特殊符号',
    },
    market: {
      not_enough_funds: '余额不足',
      missing_steam_token: '缺少Steam交易链接',
      missing_steam_id: '缺少Steam ID',
      wrong_item_status: '错误的物品状态',
      item_already_queued: '物品已处在队列中',
      max_price_limit: '最大价格限制',
      item_not_available: '物品不可用',
      steam_vac_ban: 'Steam VAC禁止',
      steam_trade_ban: 'Steam交易禁止',
      steam_private_profile: 'Steam个人档案',
      steam_private_inventory: 'Steam个人库存',
      steam_tradehold: 'Steam交易冷却',
      cannot_check_tradeban: '无法检查交易禁止',
      cannot_check_tradehold: '无法检查交易冷却',
      wrong_steam_token: 'Steam令牌错误',
      no_items_found: '物品未找到',
      items_limit: '物品限制',
      instant_sell_disabled: '即时销售已禁用',
      price_too_low: '价格过低',
    },
    steam: {
      wrong_tradelink: '错误的交易链接',
      private_inventory: '个人Steam库存',
      cannot_check_tradeban: '我们不能检查交易禁止',
      cannot_check_tradehold: '我们不能检查交易冷却',
      vac_ban: 'VAC禁止',
      trade_ban: '交易禁止',
      private_profile: 'Steam个人资料',
      tradehold: '交易冷却',
      wrong_token: '错误的令牌',
      missing_token: '缺少Steam交易链接',
      missing_steam_id: '缺少Steam ID',
      community_ban: '社区禁止',
      economy_ban: '系统禁止',
      platform_offline: '平台离线',
      cannot_check_escrow: '无法检查托管款项',
      escrow: '你正在使用电子邮件Steam令牌，这不足以与我们的机器人进行交易。你必须激活手机端Steam令牌才能与我们的机器人交易。',
      fresh_account: '你需要首先设置Steam个人资料',
    },
    mutex: {
      long_lock: '长期锁定，请在{ttl}秒后重试',
      exclusive_lock: '单独锁定',
    },
    api: {
      missing_apikey: '缺少API Key',
      missing_secret: '缺少API Secret',
      wrong_ip_address: '错误的IP地址',
      private_ip_address: '私人IP地址',
      wrong_apikey: '错误的 apikey',
    },
    record: {
      item_not_found: '物品未找到',
      item_not_owned: '物品未拥有',
      own_item: '拥有物品',
      there_are_no_records: '没有记录可显示',
      record_already_exists: '记录已经存在',
      record_not_exists: '记录不存在',
      already_exists: '已存在',
      not_exists: '不存在',
      not_updated: '未更新',
      forbidden: '禁止',
    },
    bot: {
      not_found: '未找到机器人',
      not_available: '机器人不可用',
    },
    wallet: {
      cannot_transfer_money: '无法转账',
      amount_negative: '金额为负数',
      amount_positive: '金额为正数',
      card_scoring_too_low: '信用卡评分过低',
      not_enough_balance: '没有足够的余额',
      kyc_window_limit: 'KYC窗口限制',
      service_window_limit: '服务窗口限制',
      amount_limit: '金额限制',
      wrong_wallet_address: '错误的钱包地址',
      card_not_found: '卡片未找到',
      cannot_process_transaction: '我们无法处理你的交易',
      only_past_months_accepted: '仅接受过去几个月的',
      only_visa_allowed: '仅允许使用VISA卡',
      you_cannot_complete_this_action: '你无法完成此操作，因为你的账户中没有足够的余额。',
      you_need_to_deposit_at_least_x: '你需要至少存入 {x} 才能完成此操作。',
    },
    gift_code: {
      not_found: '代码未找到',
      already_used: '代码已被使用',
      own_code: '这是你的代码',
    },
    partner: {
      subaccount_not_enabled: '子账户未启用',
      link_account_first: '首先链接账户',
      account_already_linked: '账户已经链接',
      wrong_phrase: '错误的词组',
      cannot_link_yourself: '不能链接你自己',
      account_already_exists: '用户名已被注册',
    },
    payment: {
      card_scoring: '信用卡评分过低',
      payment_issue: '付款问题',
    },
    auth: {
      failed_to_authenticate: '身份验证失败',
      not_valid_identity: '无效的身份',
      authentication_failed: '认证失败',
    },
    social: {
      cannot_create_chat: '无法创建对话',
    },
    support: {
      wrong_status: '状态错误',
      ticket_limit: '工单数量限制',
    },
    ipn: {
      verification_issue: '验证问题',
    },
    affiliate: {
      same_code: '相同的代码',
      code_taken: '此代码已被占用',
      not_activated: '未激活',
      not_enough_balance: '没有足够的余额',
    },
    bam: {
      bam_steam_015: '我们的机器人丢失了 Steam 会话。 请在几分钟后再试一次。',
    },
  },
  validator: {
    required: '此字段是必需的。',
    string: '该字段必须是字符串。',
    stringEmpty: '该字段不能为空。',
    stringMin: '该字段长度必须至少为{expected} 个字符长。',
    stringMax: '该字段长度最多必须为 {expected} 个字符。',
    stringLength: '该字段长度必须为{expected} 个字符长。',
    stringPattern: '该字段与所需的模式不匹配。',
    stringPatternLatin: '请仅使用拉丁字符。',
    stringContains: '该字段必须包含\'{expected}\' 文本。',
    stringEnum: '该字段与任何允许的值都不匹配。',
    stringNumeric: '该字段必须是数字字符串。',
    stringAlpha: '该字段必须是字母字符串。',
    stringAlphanum: '该字段必须是字母数字字符串。',
    stringAlphadash: '该字段必须是 alphadash 字符串。',
    stringHex: '该字段必须是十六进制字符串。',
    stringSingleLine: '该字段必须是单行字符串。',
    stringBase64: '该字段必须是 base64 字符串。',
    number: '该字段必须是数字。',
    numberMin: '该字段必须大于或等于{expected}。',
    numberMax: '该字段必须小于或等于{expected}。',
    numberEqual: '该字段必须等于{expected}。',
    numberNotEqual: '该字段不能等于{expected}。',
    numberInteger: '该字段必须是整数。',
    numberPositive: '该字段必须是正数。',
    numberNegative: '该字段必须是负数。',
    array: '该字段必须是一个数组。',
    arrayEmpty: '该字段不能是空数组。',
    arrayMin: '该字段必须至少包含{expected}项。',
    arrayMax: '该字段必须包含小于或等于{expected} 项。',
    arrayLength: '该字段必须包含{expected} 项。',
    arrayContains: '该字段必须包含\'{expected}\'项。',
    arrayUnique: 'The \'{actual}\' value does not unique the \'{expected}\' values.',
    arrayEnum: 'The \'{actual}\' value does not match any of the \'{expected}\' values.',
    tuple: '该字段必须是一个数组。',
    tupleEmpty: '该字段不能是空数组。',
    tupleLength: '该字段必须包含 {expected}项。',
    boolean: '该字段必须是布尔值。',
    currency: '该字段必须是有效的货币格式',
    date: '该字段必须是日期。',
    dateMin: '该字段必须大于或等于{expected}。',
    dateMax: '该字段必须小于或等于{expected}。',
    enumValue: '此字段值“{expected}”与任何允许的值都不匹配。',
    equalValue: '该字段值必须等于\'{expected}\'。',
    equalField: '该字段值必须等于\'{expected}\'字段值。',
    forbidden: '该字段为禁止字段。',
    function: '该字段必须是一个函数。',
    email: '该字段必须是有效的电子邮件。',
    emailEmpty: '该字段不能为空。',
    emailMin: '该字段长度必须至少为{expected} 个字符长。',
    emailMax: '该字段长度最多必须为 {expected} 个字符。',
    luhn: 'This field must be a valid checksum luhn.',
    mac: '该字段必须是有效的 MAC 地址。',
    object: '该字段必须是一个对象。',
    objectStrict: '该对象包含禁止的键：\'{actual}\'.',
    objectMinProps: '该对象必须至少包含{expected}属性。',
    objectMaxProps: '该对象最多只能包含{expected}个属性。',
    url: '该字段必须是有效的 URL。',
    urlEmpty: '该字段不能为空。',
    uuid: '该字段不是有效的代码格式。',
    uuidVersion: '此字段必须是提供的有效 UUID 版本。',
    classInstanceOf: '该字段必须是 \'{expected}\' 类的实例。',
    objectID: '该字段必须是有效的对象ID。',
    record: '该字段必须是一个对象。',
  },
  body: {
    language: '语言',
    currency: '货币',
    currency_warning: '所有操作均以美元执行，美元以外的货币均由美元转换而来，仅更改页面的显示方式。 货币汇率的变化可能会增加或减少您的余额。',
    choose_game: '选择游戏',
    slider: {
      title_1: '升级你的风格，',
      title_2: '主宰比赛',
      content_1: '探索终极皮肤系列',
      content_2: '提升您的游戏体验。',
      tile_1: '最大化您的游戏体验',
      tile_2: '让您的钱物有所值',
      tile_3: '享受安全、无缝的交易',
    },
    footer_description: '在 BitSkins，我们一直致力于为游戏玩家提供一个安全可靠的平台来买卖 CS2、Dota 2、Rust 和 TF2 等热门游戏中的物品。 自 2015 年推出以来，我们已成功为数百万满意的客户提供服务，并且我们对安全和保障的承诺比以往任何时候都更加坚定。',
    footer_disclaimer: '© 2015 - {year} BitSkins。 由 Steam 提供技术支持。 不隶属于 Valve 公司。',
    footer_email_support: '如果您需要帮助',
    footer_email_security: '如果您想报告漏洞',
    footer_email_partnership: '如果您想寻求合作',
    market: '市场',
    cart: '购物车',
    cart_empty: '你的购物车为空',
    clear_cart: '清空购物车',
    checkout: '结账',
    in_the_cart: '在购物车中',
    total: '总计',
    go_to_market: '去市场',
    trustpilot_alt: 'Trustpilot 拥有{stars}颗星和{reviews}  条评论',
    reload_website: '重新加载网站！',
    app_error: '应用程序错误：{error}',
    latest_articles: '最新的文章',
    steam_login: '通过Steam登录',
  },
  maintenance: {
    we_will_be_back_soon: '我们很快就回来',
    we_are_down_for_maintenance: '我们正在进行维护，但很快就会恢复在线。',
    sorry_for_the_inconvenience: '很抱歉给您带来不便，很快再见！',
  },
  account: {
    email: {
      required: '电子邮件地址为必填项',
      required_for_this_payment_method: '您无法使用此付款方式，因为您尚未设置电子邮件地址。',
      you_can_start_now: '您现在可以开始设置过程。',
      setup: '设置电子邮件',
    },
    add_funds: '充值',
    my_store: '我的商店',
    selling: '出售',
    transactions: '交易',
    settings: '设置',
    steam_settings: {
      open_settings: '打开设置',
      open_steam_settings: '打开Steam个人资料',
      what_is_steam_guard: '什么是Steam令牌？',
      inventory_status: '库存状况',
      profile_status: '个人资料状态',
    },
    logout: '登出',
    inventory: '库存',
    banned: {
      you_are_banned: '你已被 <span class="text-cr">禁止</span>',
      your_account_has_been_banned: '您的帐户因违反我们的规定而被禁止',
      your_account_has_been_blocked: '您的帐户因违反我们的规定而被封锁',
      if_you_believe: '如果您认为这是一个错误，您可以通过以下方式联系我们 <span class="text-cp">support{\'@\'}bitskins.com</span>',
      terms_of_use: '使用条款',
    },
    account_blocked: '账户 <span class="text-cr">锁定</span>',
    api_access: 'API访问',
  },
  balance: {
    wallet: '钱包',
    withdraw: '提现',
    withdraw_to: '提现至',
    withdraw_again: '提现重试',
    withdrawable: '可提现',
    total: '总计',
    balance: '余额',
    deposits_and_sales: '充值和出售',
    proceeds_from_sales: '出售收入',
    deposit: '充值',
    locked: '锁定',
    funds_locked: '交易中被锁定的资金',
    pending_withdrawals: '待提现',
    thank_you_for_your_payment: '谢谢您的付款',
    your_money_will_arrive_soon: '您的钱很快就会到账',
    your_payment_is_still_processing: '您的付款仍在处理中，但资金很快就会出现在您的帐户中。',
    in_case_you_do_not_receive: '如果您在 15 分钟内没有收到资金，请联系我们的支持人员。',
    payment_pending: '付款<span class="text-cbs">待办</span>',
    payment_failed: '付款<span class="text-cr">失败</span>',
    payment_canceled: '付款<span class="text-cg">已取消</span>',
    payment_has_been_cancelled: '付款已按要求取消',
    unfortunately_we_were_unable: '很遗憾，我们无法处理您的付款。',
    please_try_again: '请重试',
    if_the_problem_persists: '如果问题仍然存在，请联系我们的支持人员。 您还可以尝试使用其他付款方式。',
    back_to_wallet: '返回钱包',
    total_description: '来自您的充值和出售的余额。',
    withdrawable_description: '出售收入。 这些余额可以提现或用于购买物品。',
    locked_description: '暂时锁定余额，无法使用或提现。 余额被锁定的原因是现有的求购订单、购买物品等......',
    deposit_with_cryptocurrencies: '充值 <span class="text-cp">加密货币:</span>',
    deposit_with_standard_payment_methods: '充值 <span class="text-cp">标准付款方式:</span>',
    withdraw_with_cryptocurrencies: '提现 <span class="text-cp">加密货币:</span>',
    withdraw_with_standard_payment_methods: '提现 <span class="text-cp">标准付款方式:</span>',
    your_amount: '您的金额',
    your_limit: '您的限制',
    your_limits: '您的限制',
    increase_your_limits: '增加您的限制',
    payment_not_available_in_the_following_countries: '此付款方式不适用于以下国家/地区：',
    the_price_is_updated_every_60_seconds: '价格每 60 秒更新一次，是从多个交易所收集的平均价格。',
    rate_includes_x_fee: '价格包含  {x}% 的费用。',
  },
  not_found: {
    title: '找不到网页',
    message: '看起来你迷路了。 您可以<br> 在市场页面上找到您的梦想皮肤。',
  },
  login: {
    welcome_to_bitskins: '<span class="text-cp">欢迎</span> 来到 BitSkins',
    sign_in: '登入',
    sign_up: '注册',
    rules_text: '我确认我已年满 18 岁并同意',
    sign_in_with_steam: '使用 Steam 登录',
    sign_up_with_steam: '使用 Steam 注册',
    email: '电子邮箱',
    password: '密码',
    already_have_an_account: '已经有帐户？ 点击',
    to_login: '登录',
    to_login_via_email: '通过电子邮箱登录',
    login_via_email: '通过电子邮箱登录',
    log_in_using_your_email: '使用您的电子邮件地址和密码登录。',
    forgot_password: '忘记密码？',
    login_via_steam: '通过Steam登录',
    register_first: '首先你需要注册',
    passwords_not_migrated: '不幸的是，在最近的更新期间，我们无法迁移您的密码，因此您需要重置它。',
  },
  common: {
    monthly: '每月',
    x_to_y: '{x} 到 {y}',
    minimum_x: '最小{x}',
    maximum_x: '最大{x}',
    click: '点击',
    claim: '索取',
    or: '或',
    and: '和',
    confirm: '确认',
    continue: '继续',
    cancel: '取消',
    enable: '启用',
    enabled: '已启用',
    disable: '禁用',
    disabled: '已禁用',
    download: '下载',
    twofa: '双因素身份验证',
    terms_of_use: '使用条款',
    privacy_policy: '隐私政策',
    cookie_policy: 'Cookie 政策',
    about_us: '关于我们',
    changelog: '变更日志',
    faq: '常问问题',
    support: '支持',
    affiliate: '联盟营销',
    blog: '博客',
    careers: '职业机会',
    api: 'API',
    service_status: '服务状态',
    loading: '加载中...',
    buy_skins: '购买皮肤',
    sell_skins: '出售皮肤',
    popular: '热门',
    skin_categories: '皮肤类别',
    payments: '付款方式',
    about_bitskins: '关于 BitSkins',
    social_media: '社交媒体',
    follow_us: '关注我们并加入我们的社区！',
    enter_your_email: '输入你的电子邮箱地址',
    phone_number: '电话号码',
    verify: '验证',
    add: '添加',
    update: '更新',
    check_spam_folder: '如果您在收件箱中找不到该电子邮件，请检查您的垃圾邮件文件夹。',
    here: '这里',
    edit: '编辑',
    save: '保存',
    copy: '复制',
    back: '返回',
    back_to_login: '回到登入',
    clear: '清除',
    quantity: '数量',
    name: '名称',
    bot_name: '机器人名称',
    steam: 'Steam',
    steam_id: 'Steam ID',
    steam_group: 'Steam 群组',
    browser: '浏览器',
    on: '开',
    off: '关',
    hidden: '隐藏',
    empty: '空',
    expires_in: '过期日期在',
    member_since: '成为会员自',
    close: '关闭',
    paint_seed_value: '皮肤模板: {value}',
    error: '错误',
    retry: '重试',
    no_options_available: '没有可用的选项',
    search: '查找',
    any: '任意',
    min: '最小',
    max: '最大',
    no_limit: '没有限制',
    scroll_left: '向左滚动',
    scroll_right: '向右滚动',
    load: '加载',
    delete: '删除',
    remove: '清除',
    all: '所有',
    game: '游戏',
    reset: '重置',
    in: 'in',
    optional: '(自选)',
    default: '默认',
    filter: '筛选',
    up_to: '最高至',
    similar: '相似的',
    important: '重要的',
    step: '步骤',
    share_link: '分享链接',
    zoom: '价格走势',
    found: '已找到',
    try_again: '尝试重试',
    of: '共',
    timer: '定时器',
    add_new: '新增',
    and_more: '更多',
    check_status: '检查状态',
    resend_link: '重新发送链接',
    back_to_home: '回到主页',
    data_visible_only_to_logged_in_users: '此数据仅对登录用户可见',
    login: '登录',
    level: '等级',
    twofa_code: '2FA 代码',
    id: 'ID',
    position: '位置',
    amount: '金额',
    progressive_sum: '累进总和',
    date: '日期',
    active: '已激活',
    yes: '是',
    no: '否',
  },
  notifications: {
    change: '改变',
    setup: '设置',
    disconnect: '断开',
    connect: '连接',
    notifications: '通知',
    notifications_center: '通知中心',
    clear_all: '清除所有通知',
    notifications_channels: '通知渠道',
    connected: '已连接',
    all_notifications: '所有通知',
    sound: '声音',
    volume_mute: '音量静音',
    volume_full: '最大音量',
    all_sounds: '所有声音:',
    off: '关',
    on: '开',
    steam_issues_title: 'Steam 问题',
    steam_issues_content: 'Steam 服务正在波动，可能会影响交易，导致交易无法处理或创建。',
    name: {
      account_new_login: '帐号新登录',
      inventory_sold: '已出售库存',
      inventory_buyorder: '库存求购',
      wallet_deposit_done: '钱包充值完成',
      support_new_reply: '新的客服消息',
      support_ticket_closed: '工单已关闭',
      inventory_bargain_received: '收到库存还价',
    },
  },
  market: {
    non_scraped_only: '仅限无刮擦',
    set_price: '设置价格',
    game_not_found: '游戏未找到',
    game_not_available: '游戏目前无法使用',
    any_stickers: '任何贴纸',
    item_removed_from_sale: '商品已下架',
    price_updated: '更新价格',
    item_withdrawn: '物品已经取出',
    go_to_withdrawn: '取回物品',
    item_issue: '我们对此物品有疑问',
    item_in_deposit_queue: '该物品在存入队列中',
    item_in_withdraw_queue: '该物品在取回队列中',
    go_to_queued: '转到排队的物品',
    item_in_bitskins_inventory: '该物品位于您的 BitSkins 库存中',
    go_to_inventory: '转到库存',
    go_to_issue: '转到问题',
    maximum_price: '最大价格',
    minimum_price: '最小价格',
    average_price: '平均价格',
    amount_sold: '售出数量',
    withdrawal_batch_info: '请注意，我们每隔几分钟就会批量发送物品。',
    queued: '排队',
    queued_description: '在这里您可以找到排队等待提取或存入的物品。',
    withdrawn: '提取',
    withdrawn_description: '在这里您可以找到已被取回的物品。',
    issues: '问题',
    issues_description: '在这里您可以找到我们遇到问题的物品。 我们目前正在努力解决这些问题。',
    max_items_selected: '你不能选择超过 {limit} 件物品',
    item_status: '物品状态',
    search_for_stickers: '搜索贴纸',
    this_item: '(这个物品)',
    no_items_found: {
      no_items_found: '未找到物品',
      no_items_found_span: '物品 <span>未找到</span>',
      we_could_not_find_any_offers: '我们找不到任何报价',
      for: '对于',
      this_can_be_due_to_applied_filters: '这可能是由于应用了筛选。 您可以通过单击下面的按钮清除所有筛选',
    },
    only_tradable_items: '可交易的物品',
    not_accepting: '不接受',
    sell: '出售',
    skin: '皮肤',
    items: '物品',
    items_v2: '物品',
    buy_orders: '求购',
    search_for: '寻找 {game} 物品',
    search_for_items: '寻找物品',
    reload: '重新加载',
    item_name: '物品名称',
    enter_item_name: '输入物品名称',
    price: '价格',
    reset: '重置',
    all_items: '所有物品',
    sort: '种类',
    add_sort: '添加种类',
    steam_price: 'Steam 价格',
    reference_price: '参考价格',
    steam_inventory: 'Steam 库存',
    your_steam_inventory: '你的Steam库存',
    bitskins_inventory: 'BitSkins 库存',
    your_bs_inventory: '你的 BitSkins 库存 {extra}',
    refresh: '刷新',
    learn_how_to_sell: '学习如何出售',
    select_1_by_1: '1对1选择',
    select_all: '全选',
    selected_items: '已选物品',
    items_amount: '{count} 物品',
    offers: '报价',
    favorites: '收藏夹',
    last: '最后',
    viewed: '已查看',
    same_price: {
      same_price_for: '相同价格',
      all_items: '所有物品',
    },
    save_all: '全部保存',
    trade_hold: {
      name: '交易冷却',
      between: '锁定 {min} 和 {max} 天',
      less: '锁定少于 {value} 天',
      any: '任何交易冷却',
      none: '没有交易冷却',
      withdrawable_in_days_hours: '经过 {days} 天, {hours} 小时可提取',
      withdrawable_in_hours_minutes: '经过 {hours} 小时, {minutes} 分钟可提取',
      tradable: '可交易',
    },
    filter: {
      status: '状态',
      date_from: '日期自',
      date_to: '日期至',
      amount_from: '金额自',
      amount_to: '金额至',
      price_from: '价格自',
      price_to: '价格至',
      service: '服务',
      item: '物品',
      game: '游戏',
      type: '类型',
      quality: '品质',
      exterior: '外观',
      category: '类别',
      collection: '收藏品',
      color: '颜色',
      family: '皮肤家族',
      phase: '款式',
      rarity: '稀有度',
      grade: '分级',
      killstreak: '击杀记录',
      effect: '效果',
      hero: '英雄',
      nametag: '名称标签',
      hightier: '高等级',
      stickers: '贴纸',
      slot: '贴纸位置 {value}',
      paint_seed: '皮肤模板',
      paint_index: '皮肤编号',
      sticker_counter: '贴纸数量',
      float_value: '磨损度',
      active: '{value} 已激活',
      by_slot_position: '根据贴纸位置',
      filter_name: '名称过滤器',
      you_can_have: '您可以',
      filters_saved: '过滤器已保存',
      choose_stickers: '选择贴纸',
      no_stickers_found: '未找到贴纸',
      basic_filters: '基础筛选',
      advanced_filters: '高级筛选',
      clear_all_filters: '清楚所有筛选',
      save_filters: '保存筛选',
      my_filters: '我的筛选',
      filters_are_not_available_on_this_page: '过滤器在此页面不可用',
    },
    loading_item: '加载物品中',
    bestseller: '最佳出售者',
    this_is_your_item: '这是你的物品',
    action: {
      screenshot: '检视快照',
      inspect: '在游戏中检视',
      view_at_steam: '在Steam中显示',
      check_on_steam_market: '查看Steam市场',
      share: '分享',
      sell_instantly: '立刻出售',
      buy: '购买',
      remove_from_sale: '下架',
      check_on_market: '查看在售',
      item_page: '物品页面',
      bulk_buy: '批量购买',
      add_to_favorites: '添加到收藏夹',
      remove_from_favorites: '从收藏夹移除',
      buy_now: '立刻购买',
      bump: 'Bump',
      sticker: '带有此贴纸的物品',
    },
    bump_minimum: 'Bumping 仅适用于价值超过 {amount}',
    your_price: '你的价格',
    cart: {
      add_to_cart: '添加到购物车',
      remove_from_cart: '从购物车移除',
      add_stickers_to_cart: '添加贴纸到购物车',
      remove: '移除',
      in_cart: '购物车内',
    },
    details: '细节',
    tags: '标签',
    do_you_want_rename: '您想重命名您的物品吗？',
    currently_not_available: '当前不可用',
    nametag: '名称标签',
    sales: '出售',
    private_offer: '私密报价',
    private_offers: '私密报价',
    private_offers_description: '你有 {counter} 私密报价. 你可以找到它们',
    public_offer: '公开报价',
    offer_visible_only_to_people_with_link: '此报价仅对有链接的人可见',
    checkout: {
      if_any: '如果您购物车中的任何商品不再可用，它们将不会添加到您的订单中。',
      remove_all_items: '移除所有物品',
      order_summary: '订单汇总',
      you_will_save: '你将会节省',
      i_have_read: '我已阅读并同意服务条款和隐私政策，并且我了解所有购买都是最终的且不可退款。',
      confirm_checkout: '确认结账',
      you_need_to_deposit_at_least_x: '您需要存入至少{amount}才能购买购物车中的商品.',
      you_cannot_complete: '您无法完成订单，因为您的账户中没有足够的余额。您需要存入至少 {amount} 才能购买购物车中的商品.',
      these_items_will_be_removed: '结账后这些商品将从列表中删除。',
      this_item_will_not_be_included: '该商品不会包含在您的订单中',
      need_tos_accept: '您需要同意服务条款和隐私政策',
      no_items_selected: '没有选择任何物品',
    },
    deposit_status: {
      available: '可用的',
      missing: '缺少',
      not_accepting: '不允许',
      wrong_price: '错误的价格',
      already_queue: '已经在队列中',
      locked: '锁定',
    },
    withdraw_progress: {
      status: '提现状态',
      selected: '已选择',
      waiting: '等待',
      in_queue: '排队中',
      trade_link: '交易链接',
      done: '完成',
      error: '错误',
      failed: '失败',
      pending: '待办',
    },
    trade_state: {
      Invalid: '无效的',
      Active: '活跃',
      Accepted: '已接受',
      Countered: '已驳回',
      Expired: '已到期',
      Canceled: '已取消',
      Declined: '已拒绝',
      InvalidItems: '无效的物品',
      CreatedNeedsConfirmation: '已创建，需要确认',
      CanceledBySecondFactor: '被二次确认取消',
      InEscrow: '托管中',
    },
    trade_type: {
      deposit: '存款',
      withdraw: '提现',
      bidirectional: '双向',
    },
    inventory: {
      history: '历史记录',
      active_trades: '活跃的交易',
      loading_your_inventory: '正在加载你的库存',
      lower_sale_fee: '{value}% 更少的销售费用',
      group_diff_price: '并非该组中的所有商品都具有相同的价格',
      group_diff_delist: '并非组中的所有项目都被标记为下架',
      delist: '下架',
      this_may_take_a_while: '可能还要等一下',
      relist_items: '重新上架物品',
      cancel_relisting: '取消重新上架',
      cancel_withdrawal: '取消提货',
      withdraw_items: '提现物品',
      cancel_editing: '取消编辑',
      edit_items: '编辑物品',
      sell_items: '出售物品',
      steam_offers: 'Steam报价',
      clear_withdraw_items: '清除物品',
      loading_inventory: '加载库存中',
      update_x_items: '更新 {amount} 物品',
      delist_x_items: '下架 {amount} 物品',
    },
    message: {
      failed_to_create_trade_offer: '无法创建交易报价',
      offer: '报价 {hash}',
      offer_failed: '报价失败 (状态 {state})',
      offer_confirmed: '您的报价已被确认，并且您已成功列出待售物品',
      offer_sent: '您的交易报价已发送',
      open_trade: '打开交易报价',
      withdraw: '取消报价 {hash}',
      withdraw_confirmed: '您的取回已被接受',
      offer_preparing: '您的交易正在准备中。 我们将尽快向您发送报价',
      offer_active: '您的交易已准备就绪。 在这里接受',
      offer_needs_confirmation: '在手机端中确认交易',
    },
    deposit_type: {
      public: '公开',
      public_description: '所有 BitSkins 用户都可以看到您的物品。这是最受欢迎的销售选项。',
      private: '私密',
      private_description: '您的物品只有拥有链接的人才能看到。 私密销售费用比标准销售便宜 50%。',
      instant_sell: '即时销售',
      instant_description: '将物品发送到我们的机器人后，款项将立即存入您的帐户。',
    },
    click_to_open: '单击以在新选项卡中打开链接',
    no_active_trades: '没有活跃的交易',
    go_to_all_trades: '转到所有交易',
    update_trade_link: '更新交易链接',
    withdraw: '提现',
    lowest_price: '最低价格:',
    no_filters_available: '没有可用的过滤器',
    select_a_hero: '选择一个英雄:',
    view_all_items: '显示所有物品',
    stattrak: 'StatTrak™',
    item_not_available: '这个商品已经下架了',
    out_of_stock: '缺货',
    find_similar_item: '查找类似商品',
    find_similar_items: '查找类似商品',
    sell_for: '售价',
    recommended: '推荐',
    price_discounted: '打折后价格',
    price_average: '平均价格(推荐)',
    price_expensive: '高价',
    sticker: '贴纸',
    more: '更多',
    recent: '最近',
    item_not_found: '未找到物品',
    for: '价格',
    you_will_pay: '你将要支付',
    fade: '渐变: {value}%',
    see_all_items: '查看所有 {amount} 商品',
    it_my_take_a_while: '可能还要等一下',
    no_transactions_found: '没有发现交易记录',
    item: '物品',
    edit: '编辑',
    add_items_to_edit: '添加要编辑的物品',
    add_items_to_delist: '添加要下架的物品',
    add_items_to_sale: '添加要出售的物品',
    add_items_to_withdraw: '添加要提取的物品',
    group_by_name: '合并',
    select_items_from_your_inventory: '从你的库存中选择物品',
    earnings: '收入',
    total_fee: '总计费用',
    total_amount: '总计金额',
    confirm_purchase: '确认<span class="text-cp">购买</span>',
    thank_you_for_shopping_with_us: '<span class="text-cp">感谢您</span> 本次购物!',
    you_have_purchased_x_items_for: '您已购买 <span class="text-cp">{x}</span> 商品',
    you_have_purchased_x_for: '您已购买 <span class="text-cp">{x}</span> ',
    total: '总计',
    you_saved: '你节省了',
    see_your_inventory: '查看你的库存',
    you_bought: '你购买的',
    order_details: '订单细节',
    items_not_available: '很遗憾，您购物车里的部分物品已无货，无法购买。以下是这些物品清单。',
    total_price: '总计价格',
    withdraw_all_items: '提取所有物品',
    private_listing: '私密列表 {extra}',
    public_listing: '公开列表 {extra}',
    instant_sale_price: '即时销售价格',
    not_accepted: '不接受',
    not_available: '无法使用',
    no_sales_data: '没有销售数据',
    create_buy_order: '发布求购',
    active_buy_orders: '正在求购',
    buy_orders_history: '求购记录',
    market_buy_orders: '公开求购',
    recent_sales: '成交记录',
    selling_price: '出售价格',
    sales_chart: '价格走势',
    sales_history_will_be_available_soon: 'BitSkins 和 Steam 成交记录即将推出',
    souvenir: '纪念品',
    under: '{amount} 及以下',
    above: '{amount} 及以上',
    amount_to_amount: '从 {amount1} 到 {amount2}',
    discount: '折扣',
    value_off_or_more: '{value}% 折扣及更多',
    removed_items: '移除物品',
    restore_all_items: '恢复所有物品',
    add_x_items_to_edit: '添加想要编辑的 {amount} 件物品',
    add_x_items_to_sale: '添加想要出售的 {amount} 件物品',
    add_x_items_to_withdraw: '添加想要提取的 {amount} 件物品',
    sell_x_items: '出售 {amount} 件物品',
    withdraw_x_items: '提现 {amount} 件物品',
    first_you_need_to_select_an_item: '首先您需要选择一件物品。',
    cheapest_price_on_bitskins: 'BitSkins 最低售价:',
    final_price: '最终价格:',
    check_quantity: '检查数量',
    cancel_selected_orders: '取消已选订单',
    cancel_all_orders: '取消所有订单',
    community_rating: '社区评价:',
    rating: '评分',
    votes: '投票',
    open_image: '打开图片',
    cheaper_than_steam_by_x: ' 比Steam价格便宜{x}%',
    there_are_other_items_you_may_like: '<span>这里有一些其他物品</span> 你可能喜欢...',
    available_variants: '在售同款',
    picture: {
      playside: '正面',
      backside: '反面',
      steam: 'Steam市场图片',
    },
    buy_orders_not_available: '求购目前不可用',
    confirm_price_change: '确认价格变动',
    are_you_sure_to_change_price: '你确定你想把价格更改为 <span class="text-cp fw-sb">{price}</span>?',
  },
  bumps: {
    heading: '你想 <span class="text-cp">快速销售你的商品</span> 并且不降低价格吗?',
    subheading: '我们有东西给你！',
    how_it_works: '它是<span class="text-cp">如何</span> 起作用的?',
    description: '在 BitSkins，我们有一个Bump选项，允许您在市场页面和网站上的其他一些地方展示您的商品。 对于想要加快商品销售流程而又不想降低价格的人来说，这是一个完美的解决方案。 当您Bump一件物品时，会有更多人看到它，并且出售它的机会也会增加。 您只需 0.75 美元甚至更低即可开始为您的商品进行Bump（请查看我们的Bump套餐）。',
    your_active_x_autobumps: '运行中的 {x} 次自动 bumps',
    bumps_packages: 'Bumps 包',
    bumps: 'bumps',
    bumps_title: 'Bumps',
    available_bumps: '可用的 bumps',
    buy_selected_package: '购买已选套餐',
    when_you_bump: '当你bump某个物品时，它将显示在以下位置:',
    step_1_title: '在市场页面的 <span class="text-cp">顶部栏</span>',
    step_2_title: '在市场页面的 <span class="text-cp">主要部分</span>',
    step_2_text: '（仅当排序选项设置为“推荐”时。这是默认选项。）',
    step_3_title: '在 <span class="text-cp">主页</span>',
    step_4_title: '在商品页面的 <span class="text-cp">类似商品</span> 部分',
    step_5_title: '在<span class="text-cp">推荐商品</span> 部分',
    after_bumping: '<span class="text-cp">在bump以后</span> 物品将会展示在上述区域的 <span class="text-cp">第一顺位</span> 然而, <span class="text-cp">如果有人在您之后bump了他的物品</span> 那么您的物品将会被移动到 <span class="text-cp">第二顺位</span>。只要没有足够的bump将您的物品覆盖，它就会在每个区域中保持曝光。',
    how_to_bump: '<span class="text-cp">如何</span> bump我的物品?',
    how_to_1: '打开物品菜单',
    how_to_2: '选择 <span class="text-cp">bump</span> 选项',
    how_to_3: '选择bump的类型',
    how_to_4: '完成！',
    table: {
      item: '物品',
      quantity: '数量',
      left: '剩余',
      period: '持续时间',
      created_at: '创建于',
      updated_at: '更新于',
      next_bump_at: '下一个bump为',
      action: '作用',
      status: '状态',
    },
    auto_enabled: '自动bump已启用',
    auto_disabled: '自动bump已取消',
    single_bumped: '商品已经被bump！',
  },
  buy_order: {
    confirm_buy_orders_cancellation: '确认购买 <span class="color-primary">订单取消</span>',
    are_you_sure_that_you_want_to_cancel: '您确定要取消所有求购订单吗？',
    create_buy_order: '发起<span class="text-cp">求购</span>',
    predict_place_in_queue: '预测队列中的位置',
    your_place_in_the_queue: '您在队列中的位置:',
    may_purchase_items_with_trade_hold: '求购单可能会购买处于交易冷却中的物品。',
    create_a_buy_order_for_this_item: '发起该物品的求购订单',
    no_buy_orders_found: '无求购订单',
    position_in_queue: '在队列中的位置',
    this_is_your_buy_order: '(这是你的求购)',
    skin_name: '皮肤名称:',
    offers_on_market: '公开报价',
  },
  instant_sell: {
    confirmation: '即时销售确认',
    you_can_sell_x: '您可以出售 AWP | 二西莫夫（久经沙场）立即获得 10 美元。',
    the_funds_will_be_credited: '资金将立即存入您的帐户。 如果您想继续，请点击“立即出售”',
  },
  sort: {
    select_option: '选择选项',
    apply: '应用',
    clear: '清除',
    default_order_placeholder: '选择一个选项',
    select_order_placeholder: '选择排序',
    default_sort: '默认排序',
    custom_sort: '自定义',
    field: {
      price: '价格',
      discount: '折扣',
      id: '添加日期',
      bumped_at: '推荐',
      suggested_price: '建议价格',
      asset_id: '添加日期',
      float_value: '磨损度',
      paint_index: '皮肤编号',
      paint_seed: '皮肤模板',
      extras_1: '额外价值',
      extras_1_fade: '渐变',
      amount: '金额',
      name: '名称',
    },
    order: {
      price: {
        asc: '低价优先',
        desc: '高价优先',
      },
      discount: {
        desc: '最高优先',
      },
      id: {
        asc: '最早优先',
        desc: '最新优先',
      },
      asset_id: {
        asc: '最早优先',
        desc: '最新优先',
      },
      bumped_at: {
        desc: '默认',
        asc: '',
      },
      default: {
        asc: '最低优先',
        desc: '最高优先',
      },
    },
  },
  popups: {
    click_confirmation_link: '请检查您的电子邮件收件箱并单击确认链接以完成该过程。',
    steam_login_issue: {
      title: 'Steam登录问题',
      an_error_occured: '尝试通过 Steam 登录时发生错误。请再试一次。',
    },
    steam_inventory_private: {
      title: '你的 Steam 库存是<span class="text-cp">私密的</span>',
      we_were: '我们无法加载您的 Steam 库存。请将您的库存状态更改为公开。',
      you_can: '您可以在 Steam 设置中执行此操作。请记住，我们可能需要几分钟才能检测到更改。',
      steam_settings: 'Steam设置',
    },
    account_deletion_in_progress: {
      title: '账户删除正在进行中...',
      process_started: '您已开始账户删除过程。',
      account_will_be_deleted: '您的账户将被删除',
      cancel_deletion: '取消删除',
      confirm_deletion: '确认删除',
      check_your_email: '检查你的电子邮箱',
    },
    account_deletion_confirm: {
      title: '确认账户删除',
      subtitle: '你确定你想要删除你的账户？',
      once_you_confirm: '一旦您确认，您将自动注销，并且您的所有账户数据将在两周后永久删除。 在这两周内，您可以通过登录您的账户取消删除过程。',
      once_your_account_is: '删除您的账户后，您将能够通过登录网站创建新的 BitSkins 账户。',
      however_you_will_not: '但是，您将无权访问已删除的数据。',
      if_you_want_to_continue: '如果您想继续，请单击“确认”，然后单击我们发送给您的电子邮件中的确认链接。',
      login: '您需要登录才能确认删除账户',
      canceled: '账户删除已取消',
      confirmed: '账户删除已确认',
    },
    account_deletion_check_your_email: {
      title: '检查你的电子邮件',
      to_complete: '要完成账户删除过程，请单击我们发送给您的电子邮件中的确认链接。',
    },
    twofa_enable: {
      already_done: '您已启用 2FA。',
      setup_email_before: '为了启用 2FA，您需要先设置电子邮件。',
      twofa_authentication_adds: '双因素身份验证 (2FA) 需要两种方法（因素）来验证您的身份，从而为您的帐户增加了额外的安全层。 强烈建议启用 2FA 以确保您的帐户安全，因为它可以防止在无法访问额外 2FA 代码的情况下进行不必要的登录。',
      setup_twofa: '设置双因素身份验证',
      if_you_dont_have_an_authenticator_app: '如果你 <span class="text-cp">没有</span> 身份验证器应用程序',
      we_recommend: '<p>对于Android和iOS用户我们建议使用 <a href="https://support.google.com/accounts/answer/1066447?hl=en" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator</a> 或者 <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a>  . 如果您想在计算机上使用该应用程序, 您可以下载并安装 <a href="https://authy.com/download/" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Authy</a> 或在您的浏览器中使用 <a href="https://chrome.google.com/webstore/detail/authenticator/bhghoamapcdpbohphigoooaddinpkbai" rel="nofollow noopener noreferrer" target="_blank" class="text-cp">Google Authenticator 扩展应用</a>.',
      scan_the_qr_code: '<span class="text-cp">扫描</span> 二维码',
      open_your_authenticator_app: '打开您的身份验证器应用程序并扫描二维码或手动输入密钥。',
      secret_key: '密钥',
      this_secret_key_will_be_valid_for_x_seconds: '该密钥的有效期为 <span class="text-cp">{x} @:{\'time.seconds\'}</span>.',
      save_this_secret: '将此密钥保存在安全的地方。 它将允许您重新获得对 2FA 代码的访问权限<br> 当您失去对身份验证器应用程序的访问权限时。',
      enter_the_6_digit_code: '输入您的身份验证器应用程序生成的 <span class="text-cp">6位代码</span> ',
      enter_code_from_the_email: '输入来自 <span class="text-cp">邮箱</span>的代码',
      enter_the_verification_code: '输入我们发动到 <span class="text-cp">{email}</span>的验证码.',
      desktop: '桌面端',
    },
    twofa_enabled: {
      now_your_account_is: '现在您的帐户受到双因素身份验证的保护。',
      all_future_logins: '所有未来的登录现在都将要求您输入身份验证器应用程序提供的代码。',
    },
    twofa_enter_code: '输入您的身份验证器应用生成的 2FA 代码。',
    twofa_disable: {
      title: '禁用双因素身份验证',
      enter_the_6_digit_code: '输入您的身份验证应用程序生成的 6 位数代码。',
      cannot_access: '无法访问您的验证码？ 请联系我们：',
    },
    twofa_disabled: '您的帐户不再受到双因素身份验证的保护。',
    order_unable_to_process: {
      title: '我们无法<span class="text-cr">处理您的订单</span>',
      an_error_occurred: '处理您的订单时发生错误。<br> 请返回结帐页面并尝试再次下订单。',
      back_to_checkout: '返回到结帐',
      back_to_item: '返回到物品',
      information: '如果经常发生此错误您应该通过 <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">支持页面</a>联系我们，并附上错误代码:',
    },
    phone_number_add: {
      title: '添加您的手机号码',
      to_continue: '想要继续，您首先需要将电话号码添加到您的帐户。',
      add_number: '添加号码',
    },
    phone_number_confirmed: {
      title: '电话号码已确认',
      your_phone_number: '您的电话号码已被确认。',
    },
    phone_number_verify: {
      title: '验证您的电话号码',
      to_verify: '要验证您的电话号码，您必须输入我们发送至的验证码',
      enter_sms_code: '输入短信验证码',
      you_cannot_update: '您现阶段无法更新您的电话号码。. 您将能够在 {minutes} 分钟后重试.',
    },
    phone_number_verification_in_progress: {
      title: '电话号码验证正在进行中',
      if_you_wish: '如果您愿意，可以更新您的电话号码或重新发送验证码。',
      send_code: '发送代码',
    },
    email_address_add: {
      your_email_address: '您的邮箱地址',
      by_providing_my_email: '通过提供我的电子邮件地址，我同意接收营销通讯',
      verification_in_progress: '电子邮件验证正在进行中',
      to_verify: '要验证您的电子邮件地址，您必须点击我们发送至的电子邮件中的确认链接',
      if_you_wish: '如果您愿意，可以更新您的电子邮件地址或重新发送激活链接。',
    },
    email_address_verify: {
      we_are_verifying: '我们正在验证您的电子邮件地址，可能需要一段时间...',
      confirmed: '您的电子邮件地址已被确认。',
    },
    email_address_confirmed: {
      title: '电子邮件地址已被确认。',
      your_email_address: '您的电子邮件地址已被确认。',
    },
    enter_your_trade_url: {
      title: '输入您的 <span class="text-cp">交易链接</span>',
      to_continue: '想要继续，您首先需要设置您的交易链接。 你会找到它的',
      your_trade_url: '您的交易链接',
    },
    password_reset_enter_email: {
      forgot: '忘记您的',
      password: '密码？',
      dont_worry: '不用担心，请在下面输入您的电子邮件地址。',
      we_will_send: '我们将向您发送一个重置密码的链接。',
      send_reset_link: '发送重置链接',
      if_this_email: '如果此电子邮件地址与 BitSkins 帐户关联，',
      you_will_receive: '您将收到一封电子邮件，其中包含重置密码的链接。',
    },
    password_reset_new_password: {
      enter_your: '输入您的',
      new_password: '新密码',
      enter_password: '输入密码',
      repeat_password: '重复输入密码',
      save_password: '保存密码',
    },
    link_expired: {
      title: '链接已过期',
      the_process_cannot: '此过程无法完成。 该链接已经过期。',
      go_to_settings: '转到设置',
    },
    wrong_link: {
      title: '错误的链接',
      we_were_unable: '我们无法处理您的请求。 您访问了错误的链接。',
    },
    trade_preparing: {
      title: '我们正在准备您的交易报价',
      processing: '可能需要几秒钟...',
    },
    trade_sent: {
      trade_offer_has_been_sent: '您的交易报价 <span class="text-cp">已经被发送</span>',
    },
    trade_done: {
      title: '交易报价已被 <span class="text-cp">接受</span>',
      listed: '您已成功列出待售物品。您可以在 <a rel="nofollow noopener noreferrer" href="https://bitskins.com/selling" class="text-cp">出售</a>中管理它们。',
      see_listed: '查看您上架的物品',
      withdrawn: '您已成功提取您的物品。',
    },
    trade_declined: {
      your_trade_offer_has_been: '您的交易报价已经被',
      declined: '拒绝',
      if_you: '如果您自己没有拒绝，则意味着有人正在使用您的帐户，并且您的物品可能面临被盗的风险。',
      to_stay: '为了保护您的物品，应迅速采取行动并遵循以下步骤：',
      step_revoke: '撤销您的 Steam Web API Key。',
      step_revoke_btn: '撤销 API KEY',
      step_password: '更改您的Steam密码。',
      step_password_btn: '更改密码',
      step_deauth: '取消对 Steam 上所有设备的授权。',
      step_deauth_btn: '取消设备授权',
      step_trade: '创建新的 Steam 交易链接。',
      step_trade_btn: '创建新的交易链接。',
      step_new: '在 BitSkins 上设置新的交易链接。',
      step_new_btn: '设置新的交易链接',
      step_try: '尝试再次存入您的物品，看看问题是否仍然存在。',
      step_try_if: '如果这种情况继续发生，请停止所有交易并联系我们的支持人员。',
      contact_support: '联系支持人员',
      information: '请记住，我们的员工和机器人绝不会通过 Steam聊天、Discord 或其他任何地方要求任何存款 - 任何声称自己是管理员等的人都是虚假的，很可能是为了欺骗您。 注意安全！',
    },
    trade_failed: {
      offer_failed_title: '交易报价 <span class="text-cr">已失败</span>',
      offer_failed_text: '很遗憾，您的交易报价失败了。 请再试一次。',
      offer_failed_to_create_title: '创建交易报价<span class="text-cr">失败</span> ',
      offer_failed_to_create_text: '很遗憾，我们无法创建您的交易报价。 请再试一次。',
      contact_support: '如果此错误经常发生，您应该通过 <a rel="nofollow noopener noreferrer" target="_blank" href="https://bitskins.com/support" class="text-cp">支持页面</a>联系我们.',
      support_page: '支持页面',
      cannot_process: '我们无法处理您的交易报价',
      unfortunately_we_were_unable: '很遗憾，我们无法处理您的交易报价。 您很可能已经有这些商品的有效交易报价。',
    },
    items_not_available: {
      title: '商品不再出售',
      unfortunately: '很遗憾，这些在你购物车的商品 <span class="text-cy-secondary">不再出售</span>.',
      dont_worry: '别担心，您可以在市场页面上找到大量商品。',
      unavailable_items: '不可用的物品',
      back_to_market: '返回到市场',
    },
    bump_purchase_confirmation: {
      title: '购买确认',
      do_you_want_to_purchase: '你想要以<span class="text-cp">{price}</span>购买 <span class="text-cp">{quantity} bumps</span> 次数吗？',
      bumps_package: 'bumps 包',
    },
    bump_start: {
      title: 'Bump 您的物品',
      bump_your_item: 'Bump您的商品，使其出现在市场页面和网站上的其他一些地方。<br> 这可以帮助您更快地销售您的商品，因为它会被更多的人注意到。<br> 如果您想了解有关Bump功能如何工作的更多信息',
      click_here: '点击这里',
      single_bump: '单独bump',
      autobumps: '自动bump',
      one_bump: '1 bump',
      this_option_single_bump: '此选项只会对您的物品进行一次bump，费用为 <span class="text-cp">$0.75</span>。如果您的帐户上已有可用的bump次数，则不会从您的余额中扣除任何费用。',
      this_option_autobumps: '此选项将在每个选定的时间段内bump您的物品。 如果您的帐户上已有可用的bump次数，则不会从您的余额中扣除任何费用。 如果您的bump次数已用完，则每次bump都会从您的余额扣除 <span class="text-cp">$0.75</span> 。 <span class="text-cp">您可以提前购买更多的bump包</span>同时 <span class="text-cp">节省一些钱</span> - 向下滚动查看bump 包。',
      bump_every: 'Bump每一个',
      bumps_amount: 'Bumps 次数',
      delayed_start: '延迟启动',
      delayed_start_description: '通过选中此选项，您的第一次bump将延迟至选定的时间段。',
    },
    bump_stop: {
      title: '停止自动bump',
      do_you_want: '你想要停止对该物品的自动bump吗？',
    },
    bulk_buy: {
      bulk_buy: '批量 <span class="text-cp">购买</span>',
      maximum_items_you_can_buy: '您可以以此价格购买的最大数量：',
      may_purchase_items_with_trade_hold: '批量购买功能可能会购买处于交易冷却中的物品。',
    },
  },
  affiliate: {
    ad_info: '如果您没有看到该框，请尝试禁用广告拦截。',
    affiliate_code: '联盟代码',
    affiliate_link: '联盟链接',
    level: '等级',
    levels: '<span class="text-cp">联盟 </span>等级',
    our_levels: '我们的等级',
    your_code: '<span class="text-cp">您的联盟 </span>代码',
    your_affiliate_statistics: '<span class="text-cp">您的联盟 </span>统计数据',
    earn_money_by_simply_sharing: '只需与你的粉丝分享您对 BitSkins 的热爱即可<span class="text-cp">赚钱</span>！',
    percent_from_sale_fee: '{value}% 销售费',
    join_the_bitskins_affiliate: '加入 BitSkins 推广计划，通过您独特的推广链接进行的每笔销售均可赚取佣金。 无论您拥有大量粉丝或是仅仅几位好友，您分享的越多，您赚到的钱就越多。',
    tile_1_title: '向您的粉丝推荐 BitSkins',
    tile_1_description: '在几秒钟内创建您自己的推广链接，并开始与您的朋友或粉丝推荐。',
    tile_2_title: '目睹您的盈利增长',
    tile_3_title: '领取您的推广收入',
    tile_3_description: '从推广计划获得的奖励可以用于购买物品，也可以从 BitSkins 中提现。 由你决定！',
    kyc_you_cannot_use: '您无法使用推广系统，因为您尚未完成 KYC 程序。 您现在可以开始验证过程。',
    your_percentage: '您的百分比',
    generated: '生成',
    individual_affiliate_program: '个人推广计划',
    if_you_or_your_business: '如果您或您的企业涉足电子竞技行业或拥有较大的社交媒体影响力, 请通过 <span>partnership{\'@\'}bitskins.com</span>联系我们。我们将为您定制合作条款。',
    invited_referrals: '邀请推荐',
    active_referrals: '活跃的推荐',
    your_percentage_sales_fee: '您的销售费百分比',
    your_total_earnings: '您的总收入',
    available_earnings: '可用收入',
    you_can_claim_your_earnings_one_a_day: '您每天可以申领一次奖励。提交领取后，它们将在 24 小时内出现在您的可提现余额中。 最低支付金额为',
    to_reach_the_next_level: '要达到下一个级别并赚取更高的佣金, 您需要通过推荐产生 <span class="text-cp">{x}</span>销售额。 ',
    any_user_that_registers_from_your_affiliate_link: '任何通过您的推广链接注册的用户都将自动成为您的引荐用户。',
    my_earnings: '<span class="text-cgs">我的</span> 奖励',
    referred_users: '<span class="text-purple">推荐</span> 用户',
    code_updated: '联盟代码已成功更新',
    not_enough_money: '资金不足无法转账',
    account: '账户',
    referrals_sales: '推荐销售历史',
  },
  profile: {
    hi: '嗨',
    nav: {
      account: '账户',
      wallet: '钱包',
      transactions: '交易',
      statistics: '统计数据',
      affiliate: '推广',
      company: '公司',
      trades: '交易报价',
      items_history: '物品历史',
    },
    top_star: {
      you_are: '你',
      top_star: '明星',
      good_to_see_you: '嗨 "{username}", 很高兴在 BitSkins 上见到您！',
      appreciate_using: '我们感谢您决定使用我们的平台，',
      extra_settings: '因此我们为您准备了一些额外的设置。',
      show_nickname_selling: '销售时在商品页面上显示我的昵称',
      show_nickname_store: '在商店页面上高亮显示我的昵称',
    },
    basic: {
      basic_information: '基本信息',
      username: '用户名',
      change_username: '更改用户名',
      registration_date: '注册日期',
      email: '电子邮箱',
      change_email: '更改邮箱',
      password: '密码',
      change_password: '更改密码',
      phone: '电话号码',
      change_phone: '更改电话号码',
      hide_balance: '隐藏你的余额',
      hide_balance_description: '余额金额将从标题中隐藏，按下钱包后仍然可见。',
    },
    security: {
      you_can_access_your_account: '您可以通过 API Key访问您的帐户。 我们的 API 文档位于',
      api_status: 'API状态',
      security: '安全',
      twofa: '双因素身份验证',
      temporarily_block_my_account: '暂时封锁我的帐户',
      temporarily_block_title: '暂时 <span class="text-cr">封锁我的账户</span>',
      temporarily_block_description: '如果您认为您的帐户已被盗用，您可以暂时封锁它。\n联系我们的支持人员后，我们将解锁您的帐户。',
      temp_blocked: '您的帐户已被暂时封锁。\n请联系我们的支持人员以澄清情况。',
      block_my_account: '封锁我的帐户',
      delete_account: '删除账户',
      delete_my_account: '删除我的账户',
      sessions: '会话',
      close_all_sessions: '关闭所有会话',
      current_session: '当前会话',
      active_sessions: '活跃的会话',
      no_other_sessions: '没有其他会话',
      removed: '移除',
      online: '在线',
      api_key: 'API Key',
      api_key_not_available: 'API Key在创建期间仅可见一次',
      sensitive_hidden: '隐藏的敏感信息',
      ip_whitelist: 'IP白名单',
      add_ip_to_whitelist: '添加IP白名单',
      disable_api_confirm: '确认禁用 API 访问',
      disable_api_content: '您确定要禁用您账户的 API 访问吗？',
    },
    store: {
      my_store: '我的商店',
      store: '商店',
      store_url: '商店链接',
      store_alias: '商店别名',
      id_store: '商店ID',
      hide_store: '隐藏你的商店页面',
      url_copied: '商店链接已复制',
      total_items: '商品总数:',
      games: '游戏：',
    },
    setting: {
      account_email: '账户邮箱',
      update_email: '更新邮箱',
      setup_email: '设置邮箱',
      update_password: '<span class="text-cp">更新</span> 密码',
      set_password: '<span class="text-cp">设置</span> 密码',
      enter_current_password: '输入当前的密码',
      password_changed: '密码已更改',
      current_password: '当前密码',
      enter_new_password: '输入新密码',
      repeat_new_password: '重复新密码',
      save_new_password: '保存新密码',
      new_password: '新密码',
      repeat_password: '重复密码',
      account_2fa: '账户2FA',
      enable_2fa: '启用2FA',
      disable_2fa: '禁用2FA',
    },
    transaction: {
      amount: '金额',
      type: '类型',
      details: '细节',
      fee: '费用',
      buyer_country: '买家所在国',
      seller_country: '卖家所在国',
      price: '价格',
      item_name: '物品名称',
      transaction_history: '交易记录',
      operation: '操作',
      trade_id: '交易ID',
      loading_trade_offers: '加载交易报价中',
      no_trades_found: '没有找到交易报价',
      id: 'ID',
      date: '日期',
      game: '游戏',
      items: '物品',
      status: '状态',
      time_left: '剩余时间',
      action: '作用',
      trades_active: '活跃的交易',
      trades_history: '交易报价历史',
      balance: '余额',
      history: '交易记录',
      pending: '待交易',
      reports: '导出报告',
      active_locks: '活跃的锁定',
      export: '导出',
      export_to_csv: '导出到CSV',
      export_description: '选择您要生成报告的月份和年份。',
      the_report_will_appear_in_the: '该报告将出现在',
      tab_once_the_export_process_is_complete: '选项卡在导出过程完成后。',
    },
  },
  fee: {
    individual: '个人',
    individual_fee: '个人费用',
    custom_sale_fee: '您的定制销售费用',
    your_current_fees: '您的当前费用',
    high_tier: '高等级',
    fee: '费用',
    fee_up_to: '费用',
    sale_fee: '销售费用',
    sales_fees: '销售费用',
    see_all_levels: '查看所有等级',
    you_are_on: '你的',
    maximum_sales_fee: '最高销售费用: {value}',
    your_total_sale_volume: '到目前为止您的总销量是',
    sales_fees_will_be_lowered: '当您销售更多商品时，销售费用将会降低。',
    level: '等级',
    your_level: '您的等级：',
    progress: '进展：',
    max_level: '最大等级',
    next_level: '下一级：',
    total_income: '总收入',
    total_revenue: '总收入',
    sold_items: '已出售的商品',
    page: {
      sales_fees_depends_on_two_factors: '在BitSkins上  <span class="text-cp">销售费用</span> 取决于两方面:',
      the_price: '1. 您出售商品的价格',
      the_listing_type: '2. 出售类型：',
      listing_type_public: '公开 - 您的物品对网站上的所有用户可见',
      listing_type_private: '私人 - 您的物品仅对与您共享链接的人可见',
      fee_explanation: '您出售商品的价格越高，您支付的销售费用就越低。 标准销售费用为 2.5%（私密链接）至最高 10%（公开链接）。 此外，我们还有 5 种不同的销售级别，可让您进一步降低销售费用。 规则很简单 - 您出售的总价越高，您的费率就越低。 您可以将销售费用降低最多 2.4%（对于私密链接）或最多 9.8%（对于公开链接）。 我们的手续费系统是透明的，没有隐藏费用。',
      default_sales_fees_title: '<span class="text-cp">默认</span> 销售费',
      default_sale_fees_description: '如果您刚刚开始并且尚未销售任何商品，那么您的销售费用将如下：',
      how_to_reduce_my_sales_fees_title: '<span class="text-cp">如何减少</span> 我的销售费用?',
      how_to_reduce_my_sales_fees_description: '在 BitSkins 上，我们有 5 个销售级别。 每一项（1 级除外）都会使您的销售费用降低 0.05%。 要升级你的等级，你需要将你的销售总额提供到一定范围内。',
      sales_fees_levels: '销售 <span class="text-cp">费用等级</span>',
      price_range: '价格范围',
      total_sales: '总销量',
      fee_reduced_by: '费用减少了',
      individual_sales_fees_title: '个体销售费用',
      individual_sales_fees_description: '如果您正在积极使用 Bitskins 并且您的每月营业额至少为 <span class="span text-csfl6">{amount}</span>, 请随时联系我们。我们能够提供 <span class="text-csfl6">甚至更低的销售费用</span> 和 <strong>额外帮助</strong>.',
    },
  },
  copy: {
    text_copied: '复制文本',
    cannot_copy: '不能复制',
    name_copied: '复制名称',
    cannot_copy_name: '不能复制名称',
    copy_link: '复制链接',
  },
  share: {
    share_on_twitter: '分享到Twitter',
    share_on_facebook: '分享到Facebook',
    share_on_telegram: '分享到Telegram',
  },
  discord: {
    discord: 'Discord',
    already_connected: '已经连接',
    something_went_wrong: '抱歉，出错了',
    success: '成功！',
    loading: '加载中...',
    connect_with_discord: '连接到Discord',
  },
  telegram: {
    already_connected: '已经连接',
    something_went_wrong: '抱歉，出错了',
    success: '成功！',
    loading: '加载中...',
  },
  error: {
    error_404: 'Error 404',
    page_not_found: '找不到网页',
  },
  kyc: {
    description_1: '为了确保通过我们网站进行的交易的安全并遵守适用的 AML/KYC 法规，我们要求您接受数据验证流程 (KYC)。 共有三个验证级别。 每个级别都会增加或完全消除限制，并让您可以使用新的付款方式。',
    description_2_start: '我们的服务条款中描述了有关 KYC 验证流程的详细条款和条件。 我们向您保证，您提供的所有数据将按照以下规定使用',
    description_2_end: '通过启动 KYC 验证流程，您同意我们出于合法目的处理您的数据。',
    personal_data: '个人数据',
    first_name: '名',
    middle_name: '中间名',
    last_name: '姓',
    street_name: '街道名称',
    street_number: '街道号码',
    postal_code: '邮编',
    city: '城市',
    province: '省份',
    country: '国家',
    start_kyc_verification: '开始KYC验证',
    upload: '上传',
    uploaded: '已上传',
    image_uploaded: '图片已上传',
    document_type: {
      id: 'ID',
      driving_license: '驾照',
      passport: '护照',
      other: '其他',
    },
    limit: {
      crypto_withdraw: '每年的加密货币提现限额为 {amount}',
      crypto_withdraw_unlimited: '无限制的加密货币提现',
      non_crypto_withdraw: '每年的非加密货币提现限额为 {amount}',
      non_crypto_withdraw_unlimited: '无限制的非加密货币提现',
      crypto_deposit: '每年的加密货币充值限额为 {amount}',
      crypto_deposit_unlimited: '无限制的加密货币充值',
      non_crypto_deposit: '每年的非加密货币充值限额为 {amount}',
      non_crypto_deposit_unlimited: '无限制的非加密货币充值',
    },
    your_kyc_verification: '您的KYC验证',
    your_kyc_needs_an_update: '您的KYC需要 <span class="color-update">更新</span>',
    need_update_reason: '很遗憾，由于以下原因，我们无法批准您的帐户：',
    open_support: '联系支持',
    your_kyc_has_been_denied: '您的KYC已经 <span class="color-denied">被拒绝</span>',
    denied_description: '您的 KYC 已被拒绝，因此您无法再次进行 KYC 验证。',
    deleted_description: '您的 KYC 已被拒绝。 您可以再次进行验证过程。',
    please_contact_our: '请联系我们的',
    support: '支持部门',
    clarify_the_situation: '去澄清情况。',
    your: '您的',
    kyc_title: '了解您的客户 <span class="text-cp">验证</span>',
    verification: '验证',
    pending: '正在进行中',
    pending_description: '就这样！ 感谢您完成验证过程。 您的数据已成功提交。 我们将尽力尽快审核您的申请。 通常在12小时以内。 您的帐户获得批准后，我们会向您发送电子邮件。 感谢您的耐心等待。',
    do_you_need_help: '你需要帮助吗？ 请联系我们的',
    support_center: '支持中心',
    back_to_kyc: '返回到KYC',
    go_to_home: '返回主页',
    level_0: '0级',
    level_1: '1级',
    level_2: '2级',
    limits: '限制',
    benefits: '优势',
    requirements: '要求',
    no_requirements: '无要求',
    proof_of_address: '地址证明',
    all_benefits_from_the_basic_level: '基础等级的所有权益',
    personal_information: '个人信息',
    identity_document: '身份证件',
    selfie: '自拍',
    all_benefits_from_level_1: '1 级的所有权益',
    current: '当前的',
    upending: '进行中',
    update: '更新',
    verification_blocked: '验证已锁定',
    verify_now: '现在验证',
    you_need_to_upgrade_to_level_1: '你需要升级到1级',
    upgrade_to_level_1: '升级到1级',
    upgrade_to_level_2: '升级到2级',
    kyc_verification: 'KYC验证',
    kyc_verification_span: '<span class="color-primary">KYC</span> 验证',
    kyc_verification_required: '需要 KYC 验证',
    everything_done: '所有事情已完成！',
    proof_of_residency: '居住证明',
    you_current_residential_address: '您现在的居住地址',
    only_x_minutes: '只需 {minutes} 分钟!',
    identity_verification: '身份验证',
    take_a_selfie: '拍一张自拍照',
    step: '步骤 {step}',
    country_of_residence: '居住国家',
    full_name: '全名',
    date_of_birth: '生日',
    nationality: '国籍',
    choose_your_document: '选择您的文件',
    choose_document_description_1: '选择您要在验证过程中使用的文档。',
    choose_document_description_2: '我们只接受政府签发的有效文件。',
    choose_document_description_3: '清单上未列出的任何其他文件都将被拒绝。',
    document_number: '文件号码',
    country_of_issue: '签发国',
    document_issue_date: '文件签发日期',
    document_expiry_date: '文件有效期',
    files_requirements: '文件要求',
    format: '{format} 或 {or} 格式',
    maximum_file_size: '最大文件大小 {size}',
    minimum_picture_size: '最小图片 {size} 像素',
    not_accepted_documents: '不接受的文件',
    expired: '已到期',
    edited: '已编辑',
    black_and_white: '黑白',
    broken_or_damaged: '破损或损坏',
    illegible_blurred_or_reflective: '难以辨认、模糊或反光',
    cut_off_or_overcropped: '切断或过度修剪',
    upload_front_page: '上传正面',
    upload_back_page: '上传反面',
    selfie_description: '请上传一张您持有身份证件的照片以及一张写有您的姓名、“BitSkins.com”文字和今天日期的纸张。',
    example_of_correctly_taken_photo: '正确拍摄照片的示例',
    with_sunglasses_cap_or_mask: '佩戴墨镜、帽子或面罩',
    information_covered_by_finger: '您的文档信息被您的手指覆盖',
    face_covered_by_document: '你的脸被你的文件遮住了',
    out_of_focus: '您的脸部或文档不在焦点范围内',
    upload_selfie: '上传自拍照',
    send_level_1_kyc_request: '发送 1 级 KYC 请求',
    address_line_1: '地址第1行',
    address_line_2_optional: '地址第2行（可选）',
    state_or_province: '州或省',
    proof_of_residency_description: '请上传您在上一步中提供的证明您当前居住地址的文件。 确保您的全名在文档上可见。',
    upload_document: '上传文件',
    accepted_documents: '接受的文件',
    utility_bills: '水电费账单',
    bank_statements: '银行对账单',
    tax_returns: '纳税申报表',
    government_letters: '政府信件',
    other_document_residential: '确认您当前居住地址的其他文件',
    send_level_2_kyc_request: '发送 2 级 KYC 请求',
    submit: '提交',
    submit_correct: '提交正确信息',
    next: '下一个',
    send_to_verify: '发送验证',
    document_verification: '文件验证',
    level: 'KYC等级',
    please_reupload_following_photos: '请重新上传以下照片',
    please_reupload: '请重新上传',
    we_need_additional_information: '我们需要更多信息',
    file_format_not_supported: '不支持此文件格式。',
    the_file_is_too_big: '文件 {file_name} 太大 ({file_size}),<br> 最大限制 {size_limit}.',
    field: {
      document_image_a: '您的文件正面',
      document_image_b: '您的文件背面',
      user_image: '你的自拍照',
      address_image: '居住证明',
      additional_selfie: '额外的自拍照',
    },
    back_to_bitskins: '返回到BitSkins',
    withdrawals: '提现',
    get_to_the_next_level: '进入新的等级<br> 以摆脱限制<br> 并获得新的付款方式.',
    after_the_first_page_is_validated: '第一张照片通过验证后，您将可以上传第二页。',
    accepted: '已接受',
  },
  camera: {
    cancel: '取消',
    check_permissions: '检查权限',
    take_a_new_photo: '拍摄一张新照片',
    take_a_photo: '拍个照',
    use_camera: '使用相机',
    use_photo: '使用图片',
    we_will_need_access_to_your_camera: '我们需要访问您的相机才能继续。',
    please_follow_these_steps: '请按照以下步骤操作',
    select_the_camera_icon: '选择地址栏中的<strong>相机选项</strong> ',
    select_always_allow_access: '选择 <strong>始终允许访问您的相机</strong>',
    select_done: '选择 <strong>完成</strong>',
  },
  review: {
    leave_a_review: '发表评论',
    our_reviews: '我们的评论',
    if_youre_happy: '如果 <span class="color-primary">你很满意</span> 使用我们的服务, ',
    we_would_appreciate: '请在 <span class="color-primary">Trustpilot上留下评论</span>并分享您的经验来帮助我们，我们将不胜感激，谢谢你!',
    if_youre_happy_we_would_appreciate: '如果您对服务<span class="color-primary">感到满意</span> , 请在 <span class="color-primary">Trustpilot上留下评论</span> 并分享您的经验来帮助我们，我们将不胜感激. 谢谢你!',
  },
  support: {
    center: '支持中心',
    tickets_list: '工单列表',
    create_ticket: '创建工单',
    submit_ticket: '提交工单',
    close_ticket: '关闭工单',
    submit_disclaimer: '为了加快我们的工作速度并尽快收到答复，请确保您不要就同一问题开具多张工单。 平均回复时间为 <strong>几小时</strong>. 你可以用 <strong>英语、波兰语和瑞典语</strong>联系我们。谢谢您的合作。',
    enter_your_message: '输入你的信息',
    new_ticket: '新工单',
    your_ticket: '您的工单',
    bitskins_team: 'BitSkins 团队',
    ticket_has_been_closed_by: '工单已经被<span>{by}</span> <span>关闭</span> ',
    ticket_has_been_closed: '工单已经 <span>被关闭</span>',
    conversation_history: '对话历史：',
    your_reply: '您的回复...',
    send: '发送',
    ticket: '工单',
    category: {
      payments: '付款方式',
      payment_crypto_deposit: '加密货币充值',
      payment_crypto_withdraw: '加密货币提现',
      payment_standard_deposit: '标准存款方式',
      payment_standard_withdraw: '标准提现方式',
      market: '市场',
      market_item_issue: '物品问题',
      market_buy_orders: '求购',
      market_bulk_buy: '批量购买',
      market_missing_screenshot: '缺少检视快照',
      market_missing_float: '缺少磨损度',
      market_wrong_price: '错误的Steam价格',
      market_other: '其他',
      trading: '交易',
      trading_deposit: '存入物品',
      trading_withdraw: '提取物品',
      account: '账户',
      account_2fa: '2FA问题',
      account_email: '邮箱问题',
      account_kyc: 'KYC',
      account_affiliate: '推广系统',
      account_restrictions: '限制',
      account_other: '其他',
      other: '其他',
      bug_report: '报告漏洞',
      api: 'API',
      suggestions: '建议',
      business_inquiry: '商务合作',
      general_inquiry: '一般咨询',
    },
    extra: {
      txid_url: 'TXID/url',
      amount: '金额',
      crypto: '加密货币',
      disclaimer_visa_1: '请记住，款项最多可能需要 5 个工作日才能存入您的银行帐户，这是正常现象。',
      disclaimer_visa_2: '请确保您尝试提现的是 Visa 卡，而不是 Mastercard 卡。 我们目前不支持万事达卡提现。',
      card_digits: '卡号最后 4 位数字',
      binance_id: '你的币安ID',
      wallet_address: '钱包地址',
      provider: '提供者',
      transaction_id: '交易ID',
      type: '类型',
      method: '方法',
      item_link: '物品链接',
      bot_received_item: '接收您物品的机器人 Steam 个人资料的链接',
      trade_offer_id: '交易报价的ID',
      can_be_found_here: '在这里可以找到',
      email: '输入邮箱',
    },
    delete_link: '删除链接',
    add_link: '添加链接',
  },
  service: {
    market: {
      buy: '购买',
      sell: '出售',
      fee: '手续费',
      buy_order: '求购',
      bargain: '还价',
      instant_sell: '即时销售',
      bump: 'Bump',
      bump_package: 'Bump 包',
    },
    deposit: {
      gift_code: '礼品码',
      bitcoin: '充值 BTC',
      litecoin: '充值 LTC',
      ethereum: '充值 ETH',
      unlimint: '使用银行卡充值',
      binance_pay: '使用币安支付充值',
      binancepay: '使用币安支付充值',
      available_coupons: '可用优惠券：',
      redeem_coupon: '兑换代金券',
      enter_coupon_code: '输入代金券代码',
      open_binance_website: '打开币安网站',
      list_of_active_transactions: '活跃的交易列表：',
      transaction_needs_at_least_x_confirmations: '交易至少需要 {x} 次确认后资金才会出现在您的帐户中。',
      billing_information: '<span class="text-cp">计费</span> 信息',
      coupon: {
        coupon: '代金券',
        make_a_gift: '送自己或别人 <span class="text-cp">一份礼物</span>',
        bitskins_coupons_are_a_good_alternative: 'BitSkins 代金券是标准支付方式的一个很好的替代方案，也是一个很棒的礼物创意。 您可以从我们提供多种付款方式的合作伙伴处购买。',
        dont_wait: '使用BitSkins代金券<span class="text-cp">无需等待充值您的余额</span>  或者赠送某人<br> <span class="text-cp">一份原创礼物</span>（我们都知道有人的库存是空的）。 ',
        kinguin: 'Kinguin（费用新低）',
      },
      crypto: {
        get_wallet_address: '获得钱包地址',
        your_wallet_address: '你的钱包地址',
        this_address_is_only_for_x: '该地址仅适用于 {x} 存款. 不要将任何其他加密货币发送到该地址。',
        this_address_will_not_expire: '该地址不会过期。 您可以随时使用它。',
        choose_alternative_address: '选择替代地址',
        the_acutal_amount_you_will_be_credited: '您实际收到的金额取决于我们收到您付款时 {x} 的价格。',
        only_l1_transactions: '<span class="text-cy">仅支持 L1 交易。 不要使用内部交易和智能合约！</span>',
      },
      zen: {
        zen: 'ZEN 充值',
        deposit_started: 'ZEN充值开始，',
        open_the_zen_deposit_page: '打开ZEN充值页面',
        processing_fee: 'ZEN 将根据所选的付款方式向交易添加处理费。<br> 最终交易金额将在他们的网站上可见。',
        each_transaction_is_reviewed: '每笔交易均由 ZEN Pay 审核，可能需要 <span class="text-cp">1分钟或几小时</span> 才能完成。',
      },
      the_minimum_deposit_amount_is: '最小充值金额 {amount}.',
      the_maximum_deposit_amount_is: '最大充值金额 {amount}.',
    },
    withdraw: {
      only_binance_com_is_supported: '<span class="text-cy">我们仅向 binance.com 提供付款（不支持 binance.us）</span>',
      bitcoin: '提现BTC',
      litecoin: '提现LTC',
      ethereum: '提现ETH',
      unlimint: '提现到VISA卡',
      tipalti: {
        tipalti: '提现到Tipalti',
        tipalti_allows_you_to_withdraw: 'Tipalti 允许您将资金提取到您的银行和 PayPal 帐户。',
        you_dont_have_a_tipalti_acount: '您没有 Tipalti 帐户？',
        you_have_to_create_an_account: '要通过 Tipalti 提取资金，您必须首先在他们的网站上创建一个帐户。<br>您可以通过单击下面的按钮来完成此操作。',
        create_tipalti_account: '创建Tipalti帐户',
        check_your_email: '请检查 <span class="text-cp">您的邮箱收件箱</span> 并点击确认链接以完成帐户创建过程。 如果您在收件箱中找不到该电子邮件，请检查您的垃圾邮件文件夹',
        payment_method: '付款方式',
        tipalti_panel: 'Tipalti面板',
        tipalti_payouts_incur_a_fee: 'Tipalti 付款需要支付最高 26 美元的费用。 费用取决于所选的付款方式。 您可以在下面找到包含每种付款方式的费用的表格。',
        fee_per_payment: '每次付款费用',
        rejection_fee: '拒绝费用',
        echeck_local: '电子支票（本地）',
        paypal_non_us: 'PayPal（非美国居民）',
        paypal_us: 'PayPal（美国居民）',
        wire_transfer_non_us_non_usd: '电汇（非美国居民以非美元支付）',
        wire_transfer_non_us_usd: '电汇（非美国居民以美元支付）',
        wire_transfer_us: '电汇（美国居民）',
        up_to_21_usd: '高达 21.00 美元',
        up_to_2_usd: '高达 2.00 美元',
      },
      payoneer: '通过 Payoneer 提款',
      binance_pay: '使用币安支付提款',
      binancepay: '使用币安支付提款',
      p2p: '转账到P2P',
      payouts_are_performed_on_a_rolling_basis: '付款在收到请求后 5 分钟内滚动执行。',
      your_payout_will_be_processed_at_the_current_rate: '您的付款将按当前费率处理。',
      please_verify_the_wallet_address: '请验证钱包地址。 我们无法退还错误的提款。',
      the_data_controller: '无限制处理的付款的数据控制者和缔约方是 Bitskins Sp. z o.o 其注册办事处为 40-246 Katowice, Porcelanowa str。 23，Poland，registered under number：0000810143 - 更多详细信息可以在隐私政策和服务条款中找到。',
      visa_withdrawals_are_processed_instantly: 'VISA 提款将立即处理。 然而，在某些情况下，这笔钱可能需要几天的时间才会出现在您的银行帐户中。',
      card_info: '卡片信息',
      ccv: 'CCV',
      add_new_deposit_needed: '新增（需要押金）',
      you_can_have_max_3_bank_cards: '您的账户最多可以设置三张银行卡。',
      your_cards_amount: '<span class="text-cp">你的</span> 银行卡 ({x}/3)',
      the_minimum_withdraw_amount_is_x: '最小提现金额 {x}.',
      the_maximum_withdraw_amount_is_x: '最大提现金额 {x}.',
      enter_amount: '输入金额',
      go_to_card_deposit: '前往银行卡存款',
      to_be_able_to_withdraw_your_funds_you_need_to_verify_your_card: '为了能够提取资金，您需要首先验证您的卡。 您可以通过存入 1 美元来完成。',
      deposited_funds_are_non_withdrawable: '请记住，存入的资金不可提取，只能用于购买。',
      we_do_not_support_mastercard_withdrawals: '我们不支持提款至万事达卡以及以下国家/地区发行的卡：波斯尼亚和黑塞哥维那、加拿大、埃及、日本、柬埔寨、韩国(共和国)、科索沃、北马其顿、美利坚合众国、阿根廷。',
      your_card_is_valid_until: '您的卡的有效期至 16.02.2023, 15:35（世界标准时间）。 在此之后，您将需要存入 5 美元来重新验证您的卡。',
      card_verification_required: '必需<span class="text-cp">验证银行卡</span> ',
      card: '银行卡',
      add_new_card: '<span class="text-cp">添加新的</span> 银行卡',
      how_to_find_my_binance_id: '如何在币安上找到我的用户 ID (BUID)？',
      how_to_find_my_pay_id: '如何在币安上找到我的 Pay ID？',
      how_to_find_my_email: '如何在币安上找到我的电子邮件？',
      binance_id: 'Binance ID',
      receiver_type: '接收类型',
      i_do_not_have_a_binance_account: '我没有币安账户',
      i_have_a_binance_account: '我有币安账户',
      binance_account: '<span class="text-cp">Binance</span> 账户',
      the_fee_is_already_included_in_the_current_x_rate: ' {fee}% 手续费已经包含在当前 {x} 比率。',
    },
    wallet: {
      transfer: '资金转移',
      refund: '资金退款',
      available_payment_methods: '可用的付款方式',
      bank_cards: '银行卡',
      kyc_required_for_this_payment_method: '您无法使用此付款方式，因为您尚未完成 KYC 程序。 您现在可以开始验证过程。',
      kyc_limit_exceeded: '您无法使用此付款方式，因为您已超出您的 KYC 级别的交易限额。 您现在可以开始验证过程以取消限制。',
      no_limit: '无限制',
      limits_info: '在 Bitskins上 <strong>每笔交易都有自己的计时器和限制，在交易完成一年后重置</strong>。您可以存入或取出的最大金额显示在图表中。 您可以通过 KYC 程序增加限制或完全取消限制。',
      crypto_deposits: '加密货币充值',
      crypto_withdrawals: '加密货币提现',
      standard_deposits: '标准存款',
      standard_withdrawals: '标准提现',
      coupons_are_excluded_from_the_limit: '* 代金券不计入限额',
      x_type_does_not_incur_any_fees: '{x} {type}  不产生任何费用。',
      incur_fees_of: '产生费用',
      plus: '加',
      the_minimum_type_amount_is: ' <span class="color-primary">最小 {type}</span> 金额是',
      the_maximum_type_amount_is: ' <span class="color-primary">最大 {type}</span> 金额是',
      due_to_unstable_crypto_network: '由于加密网络不稳定，您可能会遇到一些延迟。',
      binance_temporarily_disabled: '周一之前禁止币安提款 (28.08.2023)',
    },
  },
  enum: {
    report_type: {
      balance: '余额',
      sell: '已出售',
      buy: '已购买',
    },
    report_status: {
      empty: '空的',
      pending: '进行中',
      done: '已完成',
    },
    autobump_period: {
      hour_1: '1小时',
      hour_3: '3小时',
      hour_6: '6小时',
      hour_12: '12小时',
      hour_24: '24小时',
      hour_48: '48小时',
    },
    autobump_status: {
      not_enough_bumps: 'bump次数不足',
      finished: '已完成',
      cancelled: '已取消',
      pending: '进行中',
      active: '活跃的',
    },
    inventory_status: {
      issue: '问题',
      not_available: '不可用',
      deleted: '已下架',
      withdrawn: '提取',
      delisted: '已下架',
      ready: '准备好',
      listed: '上架',
      listed_private: '私密上架',
      sold: '已售出',
      withdraw_queue: '提现队列',
      withdraw_pending: '提现进行中',
      instant_sell: '即时销售',
    },
    service: {
      market: {
        buy: '购买',
        sell: '出售',
        fee: '手续费',
        buy_order: '求购',
        bargain: '还价',
        instant_sell: '即时销售',
        bump: 'Bump',
        bump_package: 'Bump 包',
      },
      deposit: {
        bitcoin: '充值 BTC',
        litecoin: '充值 LTC',
        ethereum: '充值 ETH',
        unlimint: '使用银行卡充值',
        zen: 'ZEN 充值',
        gift_code: '礼品码',
        binancepay: '使用币安支付存款',
      },
      withdraw: {
        bitcoin: '提现 BTC',
        litecoin: '提现 LTC',
        ethereum: '提现 ETH',
        unlimint: '提现到 VISA 卡',
        tipalti: '提现到 Tipalti',
        payoneer: '通过 Payoneer 提款',
        binancepay: '使用币安支付提款',
        p2p: '转账到P2P',
      },
      wallet: {
        transfer: '资金转移',
        refund: '资金退款',
      },
      marketing: {
        coupon: '代金券',
        referral: '推荐',
        affiliate: '推广',
      },
    },
  },
  meta: {
    default_title: 'BitSkins 2024',
    default_description: 'BitSkins 提供了一个无缝平台来买卖您的 CS2、DOTA2、TF2、RUST 物品。 探索各种步枪、刀具、手套等。 立即加入，轻松交易！',
    home_title: 'BitSkins.com - 购买和销售 CS2 皮肤。 快速、简单、安全的交易',
    home_description: 'BitSkins 提供了一个无缝平台来买卖您的 CS2、DOTA2、TF2、RUST 物品。 探索各种步枪、刀具、手套等。 立即加入，轻松交易！',
    support_title: 'BitSkins 支持：让我们协助您的 CS2 交易需求',
    support_description: '需要 CS2 交易方面的帮助吗？ 请访问 BitSkins 支持页面以获得及时帮助。 我们的团队随时解答您的疑问、解决问题并提供指导。',
    item_title: '{item} - {game} 皮肤 | 查找并交易您想要的 {game} 物品',
    item_description_csgo: '在 BitSkins 上发现并交易您想要的 CS2 皮肤。 探索我们海量的步枪、匕首、手套等藏品。 立即购买、出售或提取。 现在就开始浏览吧！',
    item_description_cs2: '在 BitSkins 上发现并交易您想要的 CS2 皮肤。 探索我们海量的步枪、匕首、手套等藏品。 立即购买、出售或提取。 现在就开始浏览吧！',
    item_description_dota2: '在 BitSkins 上发现并交易您想要的 DOTA2 皮肤。 探索我们海量的守卫、音乐、捆绑包等。 立即购买、出售或提取。 现在就开始浏览吧！',
    item_description_tf2: '在 BitSkins 上发现并交易您想要的 TF2 物品。 探索我们海量的饰品、嘲讽、箱子等。 立即购买、出售或提取。 现在就开始浏览吧！',
    item_description_rust: '在 BitSkins 上发现并交易您想要的 RUST 物品。 探索我们大量的衣服、武器、资源等。 立即购买、出售或提取。 现在就开始浏览吧！',
    market_title: 'BitSkins 市场: 轻松探索和交易 {game} 物品',
    market_description_csgo: '进入 BitSkins 市场，轻松探索和交易各种 CS2 物品。 发现皮肤、钥匙、胶囊等的超值优惠。 立即购买、出售或提取。',
    market_description_cs2: '进入 BitSkins 市场，轻松探索和交易各种 CS2 物品。 发现皮肤、钥匙、胶囊等的超值优惠。 立即购买、出售或提取。',
    market_description_dota2: '进入 BitSkins 市场，轻松探索和交易各种 DOTA2 物品。 发现有关守卫、音乐、捆绑包等的超值优惠。 立即购买、出售或提取。',
    market_description_tf2: '进入 BitSkins 市场，轻松探索和交易各种 TF2 物品。 发现饰品、嘲讽、箱子等的超值优惠。 立即购买、出售或提取。',
    market_description_rust: '进入 BitSkins 市场，轻松探索和交易各种 RUST 物品。 发现衣服、武器、资源等的超值优惠。 立即购买、出售或提取。',
    market_item_title: 'BitSkins 市场: {skin} : {game} 市场',
    store_title: 'BitSkins 用户商店: {alias} - {game} 商品展示柜',
    store_description: 'BitSkins 用户商店展示和销售您的物品。 设定您的价格，与买家互动，并在交易社区中建立您的影响力。',
    login_title: 'BitSkins 登录：安全访问您的 CS2 交易账户',
    login_description: '安全登录您的 BitSkins 帐户。 访问您的 CS2 库存、管理物品、进行交易并享受无缝的交易体验。',
    steam_login_title: '使用 Steam 登录',
    profile_title: '您的账户设置',
    wallet_title: '您的BitSkins资金',
    affiliate_title: 'BitSkins 推广面板：通过推荐赚取奖励',
    affiliate_description: '加入 BitSkins 推广计划并通过推荐皮肤爱好者获得奖励。 联盟计划奖励丰厚，快来跟踪您的推荐来提升您的佣金吧。',
    statistics_title: 'BitSkins 销售统计：揭示市场趋势和洞察',
    statistics_description: '探索 BitSkins 的详细统计数据，以获得有关 CS2 交易趋势的宝贵洞察。 你可以分析市场数据、商品受欢迎程度等，以优化您的交易策略。',
    sales_fees_title: 'BitSkins 销售费用：透明的 CS2 出售手续费',
    sales_fees_description: '清楚了解 BitSkins 销售费用结构。 我们透明的费用可确保您的 CS2 销售公平且简单。 了解更多。',
    checkout_title: 'BitSkins 购物车：方便地采购 CS2 商品',
    checkout_description: '使用 BitSkins 购物车简化您的 CS2 交易体验。 轻松管理您的商品、查看订单并进行安全付款。 今天就享受无缝的交易流程！',
    steam_inventory_title: '我的 {game} Steam 库存',
    bs_inventory_title: '我的 {game} BitSkins 库存',
    selling_inventory_title: '我的 {game} 上架列表',
    buy_order_create_title: '在 {game} 发布求购',
    buy_order_active_title: '在 {game}中的正在求购',
    buy_order_title: '在 {game}中的求购',
    trades_active_title: '活跃的交易',
    trades_history_title: '交易历史',
    transactions_title: '交易记录',
    favorites_title: '收藏夹物品',
    kyc_title: '了解你的客户 (KYC) 申请表',
    tos_title: 'BitSkins 使用条款：安全可信交易指南',
    tos_description: '查看我们的使用条款，以获得安全可信的交易。 熟悉我们的政策和义务。 在 BitSkins 上安全地进行交易。',
    privacy_policy_title: 'BitSkins 隐私政策：保护您的个人信息',
    privacy_policy_description: '阅读 BitSkins 隐私政策，了解我们如何保护和处理您的个人信息。 信任和透明度是我们承诺的核心。',
    cookie_policy_title: 'BitSkins Cookie 政策：您的隐私对我们很重要',
    cookie_policy_description: '在 BitSkins，我们重视您的隐私。 请阅读我们的 Cookie 政策，了解我们如何使用 Cookie 和类似技术。 您的信任和数据安全是我们的首要任务。',
    docs_v1_title: 'BitSkins API V1：旧 API 版本',
    docs_v1_description: '集成 BitSkins API V1 以实现无缝交易。 访问文档以优化您的交易能力。 升级到最新版本以获得新功能。',
    docs_v2_title: 'BitSkins API V2：最新 API 版本',
    docs_v2_description: '使用 BitSkins API V2 解锁新功能。 增强您的交易策略和效率。 立即查阅我们的综合指南！',
    docs_migration_title: 'BitSkins API 迁移：无缝过渡到新 API',
    docs_migration_description: '通过我们的综合指南无缝迁移到新的 BitSkins API。 探索更新的功能和集成流程，以增强交易体验。',
  },
  alt: {
    envelope: '信封',
    app_store: 'App Store',
    google_store: 'Google Store',
  },
  time: {
    seconds: '秒',
  },
  calendar: {
    week: '周',
    month: '月',
    lifetime: '永久',
  },
  docs: {
    docs: 'Docs',
    api: 'API',
    api_v1: 'API V1 (Gateway)',
    api_v2: 'API V2',
    api_migration_guide: 'API迁移指南',
    request_parameters: '请求参数',
    sample_request: '样品请求',
    sample_response: '响应样本',
    request_schema: '请求架构',
    enums: 'ENUMS',
  },
  wallet: {
    deposit_type: '{source} {type}',
    coupon_redeemed: '您已兑换 {amount} 代金券',
    balance_changed: '余额已更新',
    transfer_p2p_confirm: '确认资金转入 p2p.bitskins.com',
    transfer_p2p_confirm_needed: '您需要确认转账',
    transfer_p2p_success: '您的资金已转入 p2p.bitskins.com',
    transfer_funds: '转移资金',
    deposit_started: '开始充值',
    card_removed: '移除银行卡',
    confirm_card_remove: '你确定你要移除这张卡吗？',
    delete_card: '删除银行卡',
    deposit: '充值',
    withdraw: '提现',
    security_code: '安全码',
    security_code_ccv: '安全码',
    card_number: '卡片号码',
    full_name: '全名',
    month_expired: '到期月 (MM/YYYY)',
    addr_line_1: '帐单地址（行1）',
    addr_line_2: '帐单地址（行2）',
    zip: '邮政编码',
    city: '城市',
    country: '国家',
    withdraw_only_to_visa: '您只能将资金提取至 Visa 卡',
    card_country_is_restricted: '遗憾的是，我们不提供对 {country}发行的银行卡的提现服务',
  },
  twofa: {
    required: '需要双因素身份验证',
    required_for_this_payment_method: '您无法使用此付款方式，因为您尚未设置双因素身份验证。',
    you_can_start_now: '您现在可以开始设置过程。',
    setup: '设置2FA',
    why_we_require: '点击阅读 - 为什么提款需要 2FA？',
  },
  password_strong: {
    minimum: '密码长度至少为 {value} 个字符',
    maximum: '密码长度最大为 {value} 个字符',
    lowercase: '密码需要至少有1个小写字符',
    uppercase: '密码需要至少有1个大写字符',
    numeric: '密码需要至少有1个数字字符',
    special: '密码需要至少有1个特殊字符',
  },
  help_center: {
    help_center: '帮助中心',
    hello: '您好，我们能帮您什么吗？',
    create_ticket: '创建工单',
    contact_us: '联系我们',
    guide: '引导',
    top_articles: '热门文章',
    didnt_find: '没有找到你需要的？',
    article: '文章',
    general: '一般的',
    fees: '费用',
    buying_selling: '买与卖',
    deposit_withdrawal: '充值与提现',
    refunds: '退款',
    user_account: '用户账户',
    affiliate: '推广联盟',
    partnership: '合作',
    scam: '涉嫌诈骗',
    was_helpful: '本文是否有帮助？',
    found_helpful: '有{yes} 人在总共 {max}人中认为有帮助',
    faq: '<span class="color-primary">常见</span> 问题',
  },
};
